import { createContext } from "react";
import type { NotificationContextType } from "./notificationConstants";

export const NotificationContext = createContext<NotificationContextType | undefined>(undefined);
